<script setup lang="ts">
import '@dabble/quillui/global'; // Global styles
import '@dabble/quillui/styles'; // Component styles
import '@fontsource-variable/inter'; // Sans-serif font
import '@fontsource/pt-serif'; // Serif font

import PageLayout from '@/components/PageLayout/PageLayout.vue';
import { connectSync } from '@/lib/patches-setup';
import { PUBLIC_PATCHES_KEY } from '@/lib/rest';
import { useAuthAccountsStore } from '@/stores/authAccounts';
import { useConfigStore } from '@/stores/config';
import { usePatchesContext } from '@dabble/patches/vue';
import { onMounted, watch } from 'vue';

const configStore = useConfigStore();
const accountsStore = useAuthAccountsStore();
const { sync } = usePatchesContext();

const isDev = import.meta.env.DEV;

// Track if we've already connected
let syncConnected = false;

// Connect sync when admin account becomes available
watch(
  () => accountsStore.accounts,
  async accounts => {
    if (syncConnected || !sync) return;

    const adminUser = accounts.find(account => account.claims?.admin);
    if (adminUser) {
      syncConnected = true;
      const authOptions = PUBLIC_PATCHES_KEY ? { token: PUBLIC_PATCHES_KEY, impersonate: adminUser.uid } : undefined;
      await connectSync(sync, adminUser.uid, authOptions);
    }
  },
  { immediate: true }
);

onMounted(async () => {
  await configStore.init();
});
</script>

<template>
  <div v-if="isDev" class="local-badge">LOCAL</div>
  <PageLayout>
    <router-view />
  </PageLayout>
</template>

<style lang="scss">
.local-badge {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 99999;
  background: #e74c3c;
  color: white;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
  padding: 2px 8px;
  border-radius: 0 4px 0 0;
  pointer-events: none;
  opacity: 0.85;
}
</style>
